export const LMSStatus = {
  default_New_Lead: {id: 1, display: "New Lead", bgColor: "", color: "", type: 0, order: 0},
  default_Not_Sold: {id: 2, display: "Not Sold", bgColor: "#fffebb", color: "", type: 0, order: 5},
  default_PNI: {id: 3, display: "PNI", bgColor: "#ffbbbb", color: "#000", type: 0, order: 4},
  default_Sold: {id: 4, display: "Sold", bgColor: "#bbffc9", color: "", type: 1, order: 3},
  default_Former_Client: {id: 5, display: "Former Client", bgColor: "#FFDF71", color: "", type: 1, order: 6},
  default_Booked: {id: 6, display: "Booked", bgColor: "#bbd5ff", color: "", type: 0, order: 1},
  default_No_Show: {id: 7, display: "No Show", bgColor: "#D89A74", color: "#000", type: 0, order: 7},
  default_Call_Back: {id: 8, display: "Call Back", bgColor: "#aa82f0", color: "#000", type: 0, order: 2},
  default_Bad_Number: {id: 9, display: "Bad Number", bgColor: "#D89A74", color: "#000", type: 0, order: 8},
  default_Working: {id: 10, display: "Working", bgColor: "", color: "", type: 0, order: 0},
  default_Followup: {id: 11, display: "Followup", bgColor: "#e2d0f4", color: "#000", type: 0, order: 9},
  default_Email_Only: {id: 13, display: "Email Only", bgColor: "#D89A74", color: "#000", type: 0, order: 10},
  default_Odd: {id: 14, display: "Odd", bgColor: "#D89A74", color: "#000", type: 0, order: 11},
  default_Converted_FSR: {id: 15, display: "Converted FSR", bgColor: "#f68fe0", color: "#000", type: 0, order: 12},
  debt_NA: {id: 100, display: "N/A", bgColor: "", color: "", type: 2, order: 0},
  debt_Contacted: {id: 101, display: "Contacted", bgColor: "", color: "", type: 2, order: 1},
  debt_New_Lead: {id: 102, display: "New Lead", bgColor: "", color: "", type: 2, order: 2},
  debt_Enrolled: {id: 103, display: "Enrolled", bgColor: "#bbffc9", color: "", type: 2, order: 3},
  debt_Not_Sold: {id: 104, display: "Not Sold", bgColor: "#fffebb", color: "", type: 2, order: 4},
  debt_PNI: {id: 105, display: "PNI", bgColor: "#ffbbbb", color: "#000", type: 2, order: 5},
  debt_Booked: {id: 106, display: "Booked", bgColor: "#bbd5ff", color: "", type: 2, order: 6},
  debt_No_Show: {id: 107, display: "No Show", bgColor: "#D89A74", color: "#000", type: 2, order: 7},
  debt_PDR_Comp: {id: 201, display: "PDR Comp", bgColor: "#bbffc9", color: "#000", type: 2, order: 7},
  debt_PDR_Other: {id: 202, display: "PDR Other", bgColor: "#bbffc9", color: "#000", type: 2, order: 7}
}

export function getLMSWBlacklistStatus(lms) {
  if (lms.blacklist === 1) {
    return {id: lms.status, display: "Blacklisted", bgColor: "#000000", color: "#FFFFFF", type: 0, order: 0}
  }
  if (lms.retired === 1) {
    return {id: lms.status, display: "Retired", bgColor: "#FF5555", color: "#000", type: 0, order: 0}
  }
  for (let key of Object.keys(LMSStatus)) {
    if (LMSStatus[key].id === lms.status) {
      return LMSStatus[key];
    }
  }
  return {id: lms.status, display: "Unknown", bgColor: "", color: "", type: 0, order: 0}
}

export function getLMSStatus(lmsStatus) {
  if (lmsStatus === -2) {
    return {id: lmsStatus, display: "Blacklisted", bgColor: "#000000", color: "#FFFFFF", type: 0, order: 0}
  }
  if (lmsStatus === -3) {
    return {id: lmsStatus, display: "Retired", bgColor: "#FF5555", color: "#000", type: 0, order: 0}
  }
  for (let key of Object.keys(LMSStatus)) {
    if (LMSStatus[key].id === lmsStatus) {
      return LMSStatus[key];
    }
  }
  return {id: lmsStatus, display: "Unknown", bgColor: "", color: "", type: 0, order: 0}
}

export function getLMSStatusList(type) {
  let arr = [];
  for (let key of Object.keys(LMSStatus)) {
    if (typeof (type) === "object") {
      if (type.indexOf(LMSStatus[key].type) > -1) {
        arr.push(LMSStatus[key]);
      }
    } else {
      if (LMSStatus[key].type === type) {
        arr.push(LMSStatus[key]);
      }
    }
  }
  return arr;
}

export function getLMSColor(lmsStatus) {

}





// WEBPACK FOOTER //
// ./src/constants/LMSConstants.js